import axios from 'axios';
import Cookies from 'js-cookie';
import router from '../router'
import store from '../store'
import NProgress from 'vue-nprogress'
const nprogress = new NProgress()


export const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 5400000,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    // 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW',
  },
  onDownloadProgress: (progressEvent) => {
    // const { loaded, total } = progressEvent;
    const { loaded } = progressEvent;
    // Do something with the progress details
    if (progressEvent.lengthComputable) {
      store.dispatch('Loading/updateLoadingPercentage', loaded)
    }
  },
});

instance.interceptors.request.use((config) => {
  nprogress.start()
  store.dispatch('Loading/updateLoading', true)
  const accessToken = Cookies.get('tendersure_token');
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
}, function (error) {
  store.dispatch('Loading/updateLoading', false)
  if (store.getters['Loading/pageLoadingTasks'].length == 0) {
    nprogress.done()
  }
  return Promise.reject(error)
});

// before a response is returned stop nprogress
instance.interceptors.response.use(response => {
  store.dispatch('Loading/updateLoading', false)
  if (store.getters['Loading/pageLoadingTasks'].length == 0) {
    nprogress.done()
  }
  return response
}, function (error) {
  store.dispatch('Loading/updateLoading', false)
  if (store.getters['Loading/pageLoadingTasks'].length == 0) {
    nprogress.done()
  }
  if ((error.response.status === 401 || error.response.status === 403) && error.response.config.url !== '/authentication/login') {
    window.toast.fire({
      icon: 'error',
      title: 'Session timed out. Please login to continue.',
    })
    store.dispatch('Auth/logout')
    store.dispatch('User/logout')
    localStorage.setItem('returnUrl', router.currentRoute.path)
    router.push('/login')
  }
  return Promise.reject(error)
})

const api = {
  request(method, url, data, successMsg = null, errorMsg = null) {
    instance.request({
      url,
      data,
      method: method.toLowerCase(),
    }).then(successMsg).catch(errorMsg);
  },

  get(url, success = null, errorMsg = null) {
    return this.request('get', url, {}, success, errorMsg);
  },

  post(url, data, success = null, errorMsg = null) {
    return this.request('post', url, data, success, errorMsg);
  },

  put(url, data, success = null, errorMsg = null) {
    return this.request('put', url, data, success, errorMsg);
  },

  patch(url, data, success = null, errorMsg = null) {
    return this.request('patch', url, data, success, errorMsg);
  },

  delete(url, data = {}, success = null, errorMsg = null) {
    return this.request('delete', url, data, success, errorMsg);
  },
};

export default api;
